import React, { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { X, Eye, EyeOff } from "lucide-react";

export default function ChangePasswordDialog({ open, onClose }) {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [show, setShow] = useState(false);
    const [busy, setBusy] = useState(false);

    if (!open) return null;

    const reset = () => {
        setCurrent(""); setNext(""); setConfirm(""); setShow(false);
    };

    const close = () => { reset(); onClose(); };

    const submit = async (e) => {
        e.preventDefault();
        if (next.length < 8) { toast.error("A nova palavra-passe deve ter pelo menos 8 caracteres"); return; }
        if (next !== confirm) { toast.error("As palavras-passe não coincidem"); return; }
        setBusy(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            toast.success("Palavra-passe atualizada");
            close();
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0d1628]/60 p-4" onClick={close} data-testid="change-password-dialog">
            <div className="bg-white border border-[#e4e4e7] max-w-md w-full p-8 relative" onClick={(e) => e.stopPropagation()}>
                <button onClick={close} className="absolute top-4 right-4 text-[#52525b] hover:text-[#0d1628]" data-testid="close-dialog">
                    <X size={18} />
                </button>
                <div className="label-caps">Segurança</div>
                <h2 className="font-display text-3xl text-[#0d1628] mt-2">Alterar palavra-passe</h2>
                <p className="text-sm text-[#52525b] mt-3">Escolha uma nova palavra-passe com pelo menos 8 caracteres.</p>

                <form onSubmit={submit} className="mt-8 space-y-6" data-testid="change-password-form">
                    <div>
                        <label className="label-caps block mb-2">Palavra-passe atual</label>
                        <input
                            type={show ? "text" : "password"}
                            required
                            className="input-clean"
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                            data-testid="cp-current"
                            autoComplete="current-password"
                        />
                    </div>
                    <div>
                        <label className="label-caps block mb-2">Nova palavra-passe</label>
                        <div className="relative">
                            <input
                                type={show ? "text" : "password"}
                                required
                                minLength={8}
                                className="input-clean pr-10"
                                value={next}
                                onChange={(e) => setNext(e.target.value)}
                                data-testid="cp-new"
                                autoComplete="new-password"
                            />
                            <button type="button" className="absolute right-0 top-1 text-[#52525b]" onClick={() => setShow(!show)}>
                                {show ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>
                    <div>
                        <label className="label-caps block mb-2">Confirmar nova palavra-passe</label>
                        <input
                            type={show ? "text" : "password"}
                            required
                            minLength={8}
                            className="input-clean"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            data-testid="cp-confirm"
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="flex gap-3 pt-2">
                        <button type="submit" disabled={busy} className="btn-primary flex-1" data-testid="cp-submit">
                            {busy ? "A atualizar..." : "Atualizar"}
                        </button>
                        <button type="button" onClick={close} className="btn-ghost" data-testid="cp-cancel">Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
